export enum NumberTypes {
    INTEGER = 0,
    FLOAT = 1
}